<template>
</template>

<script>
export default {
    data() {
        return {
            mobileMenuOpen: false
        }
    }
}
</script> 